import * as React from 'react';
import { Helmet } from 'react-helmet';
import { BirthDatePicker, DropdownInput, ToggleSwitch } from '../components/forms';
import Utils, { InputError } from '../common/utils';

interface Props {
	errors: { age: InputError };
	user: UserDetails;
	customerDetails: CustomerDemographicDetails;
	onUserChange: (e: any) => void;
	onCustomerDetailsChange: (e: any) => void;
}
interface State {
	touched: {
		age: boolean;
	};
}
class AboutYou extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			touched: {
				age: false
			}
		};
	}

	componentDidMount() {
		if (this.props.errors.age.hasError) {
			this.setState({
				touched: { ...this.state.touched, age: true }
			});
		}
	}

	handleBlur = (field: any) => (evt: any) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true }
		});
	}

	render() {
		return (
			<fieldset>
				<Helmet>
					<meta charSet="utf-8"/>
					<meta
						name="description"
						content={`Get a quote from life insurance from Mosaic life by filling out some details about yourself.`}
					/>
					<title>Get a Quote - About You | Mosaic Life </title>
				</Helmet>
				<div className="form-group">
					<div className="form-inline">
						<div className="form-group form-inline-text form-inline-text-full">My birthdate is</div>
						<div className="form-daypicker-responsive">
							<BirthDatePicker
								// Age is set in the onChange handler based on birthdate
								className="fixed-width"
								name="birthDate"
								onBlur={this.handleBlur('age')}
								onChange={this.props.onUserChange}
								value={this.props.user.birthDate}
								error={
									Utils.shouldMarkError(this.props.errors.age, this.state.touched.age)
										? this.props.errors.age
										: undefined
								}
							/>
						</div>
						<div className="form-group form-inline-text ml-0">.</div>
					</div>
				</div>
				<div className="form-group">
					<div className="form-inline">
						<div className="form-group form-inline-text form-inline-text-full">My sex at birth is</div>
						<DropdownInput
							name="gender"
							defaultOption="Select"
							options={[{ text: 'Male', value: 'male' }, { text: 'Female', value: 'female' }]}
							onChange={this.props.onUserChange}
							value={this.props.user.gender}
						/>
						<div className="form-group form-inline-text ml-0">.</div>
					</div>
				</div>
				<div className="form-group mb-0">
					<div className="form-inline">
						<div className="form-group form-inline-text form-inline-text-full">I</div>
						<ToggleSwitch
							name="isSmoker"
							onChildren="Do"
							offChildren="Do not"
							onChange={this.props.onCustomerDetailsChange}
							checked={this.props.customerDetails.isSmoker}
							className="toggle-do-donot"
						/>
						<div className="form-group form-inline-text form-inline-text-full">use tobacco.</div>
					</div>
				</div>
			</fieldset>
		);
	}
}
export default AboutYou;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/AboutYou.tsx